"use strict";

(function () {
  'use strict';

  angular.module('filter.package-specials', []).filter('packageSpecials', packageSpecials);
  packageSpecials.$inject = [];
  /* @ngInject */

  function packageSpecials(specialsAarr) {
    return function (specialsAarr) {
      if (specialsAarr) {
        return specialsAarr.filter(function (special) {
          return special.specialType === 3;
        });
      } else {
        return specialsAarr;
      }
    };
  }
})();